import React from 'react';

interface ChatHeaderProps {
  contractorName: string;
  isVerified: boolean;
  status: string; // e.g., "Online", "Active now"
  responseTime?: string;
  specialization?: string;
  onBackClick?: () => void;
  isMobile?: boolean;
  isDesktop?: boolean;
  profileImageUrl: string; // Added profileImageUrl
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  contractorName,
  isVerified,
  status,
  responseTime,
  specialization,
  onBackClick,
  isMobile,
  isDesktop,
  profileImageUrl, // Destructure profileImageUrl
}) => {
  if (isMobile) {
    return (
      <div className="px-container-margin h-16 flex items-center gap-4 border-b border-outline-variant bg-white md:hidden">
        <button className="text-primary" onClick={onBackClick}>
          <span className="material-symbols-outlined" data-icon="arrow_back">arrow_back</span>
        </button>
        <div className="flex items-center gap-3">
          {/* Avatar */}
          <div className="w-10 h-10 rounded-lg overflow-hidden">
            <img src={profileImageUrl} alt="Avatar" className="w-full h-full object-cover" />
          </div>
          <div className="flex flex-col">
            <span className="font-label-bold text-label-bold text-primary">{contractorName}</span>
            <span className="text-[10px] text-green-600 font-bold">{status}</span>
          </div>
        </div>
      </div>
    );
  }

  if (isDesktop) {
    return (
      <header className="h-16 px-gutter flex items-center justify-between border-b border-outline-variant bg-surface z-10">
        <div className="flex items-center gap-4">
          {/* Avatar */}
          <div className="relative">
            <div className="w-10 h-10 rounded-lg overflow-hidden">
              <img src={profileImageUrl} alt="Avatar" className="w-full h-full object-cover" />
            </div>
            {status === 'Active now' && ( // Changed from 'Online' to 'Active now' to match sample data
              <span className="absolute bottom-[-1px] right-[-1px] w-3 h-3 bg-green-500 border-2 border-surface rounded-full"></span>
            )}
          </div>
          <div>
            <div className="flex items-center gap-1.5">
              <h2 className="font-headline-sm text-headline-sm text-primary">{contractorName}</h2>
              {isVerified && (
                <span className="material-symbols-outlined text-[18px] text-green-600" data-icon="verified" style={{ fontVariationSettings: "'FILL' 1" }}>verified</span>
              )}
            </div>
            <div className="flex items-center gap-1.5">
              <span className="text-label-md font-label-md text-outline">{status}</span>
              {responseTime && (
                <>
                  <span className="w-1 h-1 bg-outline-variant rounded-full"></span>
                  <span className="text-label-md font-label-md text-outline">Response time: {responseTime}</span>
                </>
              )}
              {specialization && (
                <>
                  <span className="w-1 h-1 bg-outline-variant rounded-full"></span>
                  <span className="text-label-md font-label-md text-outline">{specialization}</span>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button className="p-2 rounded-lg hover:bg-surface-container-low text-primary transition-colors">
            <span className="material-symbols-outlined" data-icon="call">call</span>
          </button>
          <button className="p-2 rounded-lg hover:bg-surface-container-low text-primary transition-colors">
            <span className="material-symbols-outlined" data-icon="videocam">videocam</span>
          </button>
          <button className="p-2 rounded-lg hover:bg-surface-container-low text-primary transition-colors">
            <span className="material-symbols-outlined" data-icon="info">info</span>
          </button>
        </div>
      </header>
    );
  }

  return null;
};

export default ChatHeader;
